'use client'

/**
 * Training Completion Fail-Safe Component (Issue #3228)
 *
 * Client component that uses the fail-safe hook to read the
 * complete_training query parameter and mark training items complete.
 *
 * Renders nothing - purely for side effects.
 * Must be wrapped in a Suspense boundary because it uses useSearchParams.
 */

import { useTrainingCompletionFailsafe } from '@/hooks/use-training-completion-failsafe'

export function TrainingCompletionFailsafe() {
  useTrainingCompletionFailsafe()
  return null
}
